import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;
const getTempersList = (page, pagesize, search, ordering) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/temper/`, {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering
    },
  });
};

const getTemperDropdown = (page, pagesize, search, ordering) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/temper/`, {
    headers: authHeader(),
    params: {
     // fields: 'id,name,code,deleted',
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering
    },
  });
};

const getArchiveTempersList = (page, pagesize, search) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/temper/archive-list', {
    headers: authHeader(), params: {
      page: page,
      pagesize: pagesize,
      search: search
    }
  });
};
const addTempers = (newTempers) => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/temper/`,
    newTempers,
    { headers: authHeader() }
  );
};
const updateTempers = (id, updatedData) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/temper/${id}/`,
    updatedData,
    { headers: authHeader() }
  );
};

const archiveTemper = (id) => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/temper/${id}/archive/`, // Include the die group's ID in the URL
    {},
    { headers: authHeader() } // Authentication header
  );
};
const unArchiveTemper = (id) => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/temper/${id}/unarchive/`, // Include the die group's ID in the URL
    {}, // Pass an empty object if no data needs to be sent
    { headers: authHeader() } // Authentication header
  );
};
const tempersListService = {
  getTempersList,
  getArchiveTempersList,
  addTempers,
  updateTempers,
  archiveTemper,
  unArchiveTemper,
  getTemperDropdown
};

export default tempersListService;
